export const questionnaireFormattedPrefillValues = {
	radiators: 'radiating',
	Boiler: 'boiler',
	'Mid-Terrace': 'Mid-terrace',
};

export const numberWithOptionalDecimalRegExp = /^\d{1,}$|^\d+\.\d{0,}$/;
